import {AnalyticsBrowser} from '@segment/analytics-next'

let segmentAnalytics = null
let segmentReadyResolve
const segmentReady = new Promise((resolve) => {
    segmentReadyResolve = resolve
})

export const initializeSegment = async (segmentKey) => {
    if (!segmentKey || segmentAnalytics) return
    try {
        const [analytics] = await AnalyticsBrowser.load({writeKey: segmentKey})
        segmentAnalytics = analytics
        segmentReadyResolve(analytics)
    } catch (error) {
        console.error('Error initializing Segment Analytics:', error)
        segmentReadyResolve(null)
    }
}

export const getSegmentInstance = () => segmentAnalytics

export const getSegmentReady = () => segmentReady
